import React, { memo, useMemo } from "react";
import { useFocusTrap, useI18n } from "Hooks";
import { List } from "@toddle-edu/ds-web";
import classes from "./ConfigureColumnsOverlay.scss";
import PropTypes from "prop-types";
import _ from "lodash";
import classNames from "classnames";

const ConfigureColumnsOverlay = props => {
  const {
    testId,
    data,
    selectedColumns,
    onSelectColumn,
    onReorderColumns,
    title,
    overlayContainerStyle = {},
    titleStyle,
    isDraggable = true,
  } = props;
  const { t } = useI18n(["common"]);
  const containerRef = useFocusTrap({
    isActive: true,
  });

  const processedData = useMemo(() => {
    return _.map(data, item => ({
      ...item,
      value: <div className={classes.value}>{item.value}</div>,
    }));
  }, [data]);

  return (
    <div
      className={classes.overlayContainer}
      style={overlayContainerStyle}
      ref={containerRef}
    >
      <div
        className={classNames("text-label", classes.title)}
        style={titleStyle}
      >
        {title || t("common:configure_columns")}
      </div>
      <div
        className={classNames(classes.listContainer, {
          [classes.listContainerWithLeftPadding]: !isDraggable,
        })}
      >
        <List
          data={processedData}
          rowsSelected={selectedColumns}
          isDraggable={isDraggable}
          showSelection
          selectionType="checkbox"
          selectItemPosition="right"
          onChange={onReorderColumns}
          onRowSelection={onSelectColumn}
          listItemClassName={classes.listItem}
          testId={testId}
        />
      </div>
    </div>
  );
};

ConfigureColumnsOverlay.defaultProps = {
  testId: "UIComponents-ConfigureColumnsOverlay",
  titleStyle: {},
};

ConfigureColumnsOverlay.propTypes = {
  testId: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectColumn: PropTypes.func.isRequired,
  onReorderColumns: PropTypes.func.isRequired,
  title: PropTypes.string,
  overlayContainerStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  isDraggable: PropTypes.bool,
};

ConfigureColumnsOverlay.displayName = "ConfigureColumnsOverlay";
export default memo(ConfigureColumnsOverlay);
